module.exports = __webpack_public_path__ + "static/settings-min-min-2594a38d48306b37357a903fd9c6d482.png";